// extracted by mini-css-extract-plugin
export default {"input":"styles_input__0aKuG","input__main":"styles_input__main__Q7Nbp","error":"styles_error__x5GAd","borderError":"styles_borderError__-Qmy0"};